import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

type LoadingSpinnerProps = {
  message?: string;
};

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ message }) => {
  return (
    <Box
      sx={{
        minHeight: '40vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 1.5,
      }}
    >
      <CircularProgress size={60} thickness={5} />
      {message ? (
        <Typography
          sx={{
            color: 'rgba(234,242,255,.72)',
            fontSize: 13,
            fontWeight: 700,
          }}
        >
          {message}
        </Typography>
      ) : null}
    </Box>
  );
};

export default LoadingSpinner;